export const setCookie = (
  name: string,
  value: string,
  httpOnly: boolean,
  daysToExpire?: number,
  path?: string
): void => {
  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (path) {
    cookieString += `; path=${path}`;
  }

  if (daysToExpire) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + daysToExpire);
    cookieString += `; expires=${expirationDate.toUTCString()}`;
  }
  if (httpOnly) {
    document.cookie = `${cookieString} ; secure; HttpOnly`;
  } else document.cookie = `${cookieString} ; secure;`;
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }

  return null;
};

export const deleteCookie = (name: string): void => {
  // Expire both the default-path copy (how older code wrote it) and the
  // site-wide `/` copy (how the api-key store rewrites `ses_userdata`).
  setCookie(name, "", false, -1);
  setCookie(name, "", false, -1, "/");
};
